// @flow
import * as React from 'react';
import { connect } from 'react-redux';
import { masked } from 'store/reducers/ajaxCall/selectors';
import { getSciIsNavigating } from 'store/reducers/selfCheckIn/selectors';

import { Mask, LoadingSelfCheckIn } from 'components/atoms/Mask';

type Props = {|
  masked: boolean,
  isNavigating: boolean
|};

// eslint-disable-next-line react/prop-types
const AppMask = ({ masked, isNavigating }: Props) => {
  if (masked) {
    return <Mask />;
  }
  if (isNavigating) {
    return <LoadingSelfCheckIn />;
  }
  return null;
};

function mapStateToProps(state): $Shape<Props> {
  return {
    masked: masked(state),
    isNavigating: getSciIsNavigating(state)
  };
}

export default connect(mapStateToProps)(AppMask);



// WEBPACK FOOTER //
// ./src/components/selfCheckIn/AppMask.js